import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link } from "react-router-dom";

/**
 * WrongPanDetail component displays an error message for invalid PAN details.
 * Shows entered PAN number and provides navigation to edit it.
 */
const WrongPanDetail = ({ login = null }) => {
  const location = useLocation();
  const panNumber = location.state?.panNumber || "";
  const userId = location.state?.userId || "";
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')


  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="40%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/new1-error.png")}
              />
              <h6 className="mt-5">PAN is not Valid</h6>
            </div>

            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>PAN Card Number</label>
              <p>{panNumber.pan_number}</p>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              <Link to={`/${redirectUrl}/pan-card/${userId}`}>
                <button type="button" className="btn bgdark-blue text-white">
                  Edit
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default WrongPanDetail;
